import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTelemetry } from "./TelemetryContext";

/**
 * Component that tracks navigation events when routes change
 */
export function NavigationTracker(): null {
  const location = useLocation();
  const { trackNavigation } = useTelemetry();

  useEffect(() => {
    // Track page view on route change
    trackNavigation(location.pathname, {
      search: location.search,
      hash: location.hash,
      referrer: document.referrer,
      title: document.title,
    });
  }, [location, trackNavigation]);

  return null;
}
